var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepositorioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054.29,0H25.71C11.5,0,0,11.5,0,25.71v1028.57c0,14.21,11.5,25.71,25.71,25.71h1028.57c14.21,0,25.71-11.5,25.71-25.71V25.71c0-14.21-11.5-25.71-25.71-25.71ZM1028.57,1028.57H51.43V51.43h977.14v977.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.68,936.06h740.62c14.21,0,25.71-11.5,25.71-25.71V169.7c0-14.21-11.5-25.71-25.71-25.71H169.68c-14.21,0-25.71,11.5-25.71,25.71v740.64c0,14.21,11.5,25.71,25.71,25.71ZM195.39,884.63v-318.92h689.19v318.92H195.39ZM884.58,195.42v318.87H195.39V195.42h689.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.35,644.56h-290.69c-14.21,0-25.71,11.5-25.71,25.71v129.93c0,14.21,11.5,25.71,25.71,25.71s25.71-11.5,25.71-25.71v-104.21h239.26v104.21c0,14.21,11.5,25.71,25.71,25.71s25.71-11.5,25.71-25.71v-129.93c0-14.21-11.5-25.71-25.71-25.71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.65,469.84c14.21,0,25.71-11.5,25.71-25.71v-104.21h239.26v104.21c0,14.21,11.5,25.71,25.71,25.71s25.71-11.5,25.71-25.71v-129.93c0-14.21-11.5-25.71-25.71-25.71h-290.69c-14.21,0-25.71,11.5-25.71,25.71v129.93c0,14.21,11.5,25.71,25.71,25.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepositorioIcon);
export default __webpack_public_path__ + "static/media/RepositorioIcon.95793615e6ab32236fe503169a2fc0db.svg";
export { ForwardRef as ReactComponent };